import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import SetMarketingStatusActionDetail from 'automation-ui-action-features/deprecated/set-marketing-status/SetMarketingStatusActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
const SetMarketingStatusActionHistoryCard = ({
  actionLabel,
  actionMetadata
}) => /*#__PURE__*/_jsx(LogEventRowAction, {
  title: actionLabel,
  content: /*#__PURE__*/_jsx(SetMarketingStatusActionDetail, {
    actionMetadata: actionMetadata
  })
});
export default SetMarketingStatusActionHistoryCard;